import React from 'react'

import { formatImageURL } from 'src/lib/js/utilities'

import { UpsellItem } from 'public/components/default_template/online_ordering/upsell/UpsellItem'
import { getUpsellItemPrice } from 'public/components/default_template/online_ordering/upsell/utils/upsellUtils'

interface UpsellImageCardProps {
  item?: UpsellItem
  onItemSelect: () => void
}

export const UpsellImageCard = (props: UpsellImageCardProps) => {
  const { item, onItemSelect } = props

  if (!item) {
    return <></>
  }

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.code === 'Enter' || e.code === 'Space') {
      onItemSelect()
    }
  }

  return (
    <div
      role='button'
      className='imageUpsellItemGrid'
      data-testid={`upsell-image-card-${item.guid}`}
      onClick={onItemSelect}
      onKeyDown={onKeyDown}
      tabIndex={0}
    >
      <div className='image'>
        <img
          className='imgWrapper'
          src={formatImageURL(item.imageUrls.xs)}
          alt=''
          data-testid={item.name + '-image'}
        />
        <div className='quickAdd'>
          <div className='upsellQuickAddBtn' aria-hidden>
            +
          </div>
        </div>
      </div>
      <p className='title'>{item.name}</p>
      <p className='price'>{getUpsellItemPrice(item)}</p>
    </div>
  )
}
